module.exports = __webpack_public_path__ + "img/logonew.94d96c0c.svg";